import {
  convertToDayJs,
  getCurrentTime,
} from 'shared/src/utils/date-utils';
import { isNotNil } from 'shared/src/utils/isNotNil';

export type BottomDockedTimeSaleBanner = {
  title: string;
  finishedAt: string;
};

type PromotionCountdownLike = {
  banner_title?: string | null;
  finished_at?: string | null;
} | null;

type TimeSaleBannerLike = {
  title: string;
  finished_at: string;
} | null;

/** promotion_countdown 하단 배너 노출 상한 (3일) */
const PROMOTION_COUNTDOWN_MAX_MS = 3 * 24 * 60 * 60 * 1000;

/**
 * 하단 도킹 타임세일 배너 해석.
 * - banner_title·finished_at이 있으면 time_sale_banner로 폴백하지 않는다
 * - 잔여 < 72h이고 만료 전일 때만 노출, 그 밖은 null → 넛지 복귀
 * - promotion_countdown이 없으면 time_sale_banner (미래인 경우만 노출)
 */
export const resolveBottomDockedTimeSaleBanner = ({
  promotionCountdown,
  timeSaleBanner,
}: {
  promotionCountdown: PromotionCountdownLike;
  timeSaleBanner: TimeSaleBannerLike;
}): BottomDockedTimeSaleBanner | null => {
  const now = getCurrentTime();
  const promoTitle = promotionCountdown?.banner_title;
  const promoFinishedAt = promotionCountdown?.finished_at;

  if (isNotNil(promoTitle) && isNotNil(promoFinishedAt)) {
    const finishedMs = convertToDayJs(promoFinishedAt).valueOf();
    if (Number.isFinite(finishedMs)) {
      if (finishedMs > now && finishedMs - now < PROMOTION_COUNTDOWN_MAX_MS) {
        return {
          title: promoTitle,
          finishedAt: promoFinishedAt,
        };
      }
      return null;
    }
  }

  if (isNotNil(timeSaleBanner)) {
    const finishedMs = convertToDayJs(timeSaleBanner.finished_at).valueOf();
    if (Number.isFinite(finishedMs) && finishedMs > now) {
      return {
        title: timeSaleBanner.title,
        finishedAt: timeSaleBanner.finished_at,
      };
    }
  }

  return null;
};
